import {
  Box,
  Button,
  Card,
  CardMedia,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, {useEffect, useState} from "react";
import useStyles from "./style";
import {ListSlideMonth, SlideMonth} from "models/managerLesson";
import managerLessonApi from "api/managerLesson";
import BACKGROUND_1234 from "assets/img/slide_month_1234.png";
import BACKGROUND_5678 from "assets/img/slide_month_5678.png";
import BACKGROUND_9101112 from "assets/img/slide_month_9101112.png";
import {useNavigate} from "react-router-dom";
import CarouselMonthMobile from "./components/CarouselMonthMobile";
import {useTranslation} from "react-i18next";

import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import EventNoteIcon from "@material-ui/icons/EventNote";
import WhatshotIcon from "@material-ui/icons/Whatshot";

export default function CarouselMonth() {
  const classes = useStyles();
  const currentMonth = new Date().getMonth() + 1;
  const {t} = useTranslation();
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [listSlideMonth, setListSlideMonth] = useState<SlideMonth[]>([]);
  const navigate = useNavigate();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints?.down("sm"));

  useEffect(() => {
    (async () => {
      try {
        const res: ListSlideMonth<SlideMonth> = await managerLessonApi.getSlideMonth(year);
        setListSlideMonth(res.lessionOverview);
      } catch (error) {}
    })();
  }, [year]);

  const getThemeByMonth = (month: number) => {
    if (month < 5) {
      return {
        accent: "#E11D48",
        bg: "#FFF1F2",
        border: "#FECDD3",
        gradient: "linear-gradient(135deg, #F43F5E 0%, #E11D48 100%)",
        trackBg: "#FFE4E6",
      };
    } else if (month < 9) {
      return {
        accent: "#D97706",
        bg: "#FFFBEB",
        border: "#FDE68A",
        gradient: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
        trackBg: "#FEF3C7",
      };
    } else {
      return {
        accent: "#2563EB",
        bg: "#EFF6FF",
        border: "#BFDBFE",
        gradient: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)",
        trackBg: "#DBEAFE",
      };
    }
  };

  return isTablet ? (
    <CarouselMonthMobile />
  ) : (
    <Box className={classes.container}>
      {/* Header Banner */}
      <Box className={classes.headerBanner}>
        <Box className={classes.headerTitleGroup}>
          <Box className={classes.headerIconPill}>
            <EventNoteIcon style={{ fontSize: 26 }} />
          </Box>
          <Box>
            <Typography className={classes.headerTitle}>
              DANH SÁCH BÀI HỌC THEO THÁNG
            </Typography>
            <Typography className={classes.headerSubtitle}>
              Theo dõi tiến độ học tập và chọn tháng để bắt đầu học
            </Typography>
          </Box>
        </Box>

        <FormControl variant="outlined" className={classes.formControl}>
          <Select
            value={year}
            onChange={(e: any) => setYear(Number(e.target.value))}
            displayEmpty
            IconComponent={ExpandMoreIcon}
            renderValue={(selected: any) => (
              <Box style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <CalendarTodayIcon style={{ fontSize: 18, color: "#2563EB" }} />
                <span>Năm {selected}</span>
              </Box>
            )}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              getContentAnchorEl: null,
              PaperProps: {
                style: {
                  borderRadius: 16,
                  marginTop: 8,
                  boxShadow: "0 12px 32px rgba(15, 23, 42, 0.15)",
                  border: "1px solid #E2E8F0",
                  maxHeight: 280,
                },
              },
            }}
          >
            {Array.from(new Array(10)).map((_, index) => {
              const yearValue = index + 2020;
              return (
                <MenuItem
                  key={yearValue}
                  value={yearValue}
                  style={{
                    borderRadius: 8,
                    margin: "2px 6px",
                    fontWeight: year === yearValue ? 800 : 600,
                    fontSize: "0.9rem",
                    color: year === yearValue ? "#2563EB" : "#334155",
                    backgroundColor: year === yearValue ? "#EFF6FF" : "transparent",
                  }}
                >
                  Năm {yearValue}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>

      {/* Month Cards Grid on PC */}
      <Grid container spacing={3}>
        {listSlideMonth?.map((item) => {
          const monthTheme = getThemeByMonth(item.month);
          const percent = item.noTotalLession > 0 
            ? Math.round((item.noWatchedLession / item.noTotalLession) * 100) 
            : 0;

          return (
            <Grid item xs={12} sm={6} md={4} lg={3} key={item.month}>
              <Card className={classes.card}>
                {/* Media Banner Header */}
                <CardMedia
                  className={classes.contentMedia}
                  image={
                    item.month < 5
                      ? BACKGROUND_1234
                      : item.month < 9
                      ? BACKGROUND_5678
                      : BACKGROUND_9101112
                  }
                >
                  <Box className={classes.mediaTopRow}>
                    {item.month === currentMonth && (
                      <Box className={classes.activeMonthChip}>
                        <WhatshotIcon style={{ fontSize: 14, marginRight: 4 }} /> THÁNG HIỆN TẠI
                      </Box>
                    )}
                  </Box>
                  <Typography className={classes.monthTitle}>
                    THÁNG {item.month < 10 ? `0${item.month}` : item.month}
                  </Typography>
                </CardMedia>

                {/* Card Body */}
                <Box className={classes.cardBody}>
                  <Typography className={classes.progressLabel}>
                    {t("home.carousel.sobaihocdahoanthanh")}
                  </Typography>

                  <Box className={classes.totalWatchedRow}>
                    <Typography className={classes.totalWatchedNum} style={{ color: monthTheme.accent }}>
                      {item.noWatchedLession}
                    </Typography>
                    <Typography className={classes.totalWatchedDenom}>
                      / {item.noTotalLession} bài ({percent}%)
                    </Typography>
                  </Box>

                  {/* Progress Bar */}
                  <Box className={classes.progressBarTrack}>
                    <Box
                      className={classes.progressBarFill}
                      style={{
                        width: `${percent}%`,
                        backgroundColor: monthTheme.accent,
                      }}
                    />
                  </Box>

                  {/* Action Button */}
                  <Button
                    className={classes.btn_detail}
                    style={{ background: monthTheme.gradient }}
                    endIcon={<ArrowForwardIcon />}
                    onClick={() =>
                      navigate({
                        pathname: "/list-lesson",
                        search: `year=${year}&month=${
                          item.month < 10 ? `0${item.month}` : item.month
                        }`,
                      })
                    }
                  >
                    {t("home.vaohoc")}
                  </Button>
                </Box>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
